import getDayName from '../get-day-name';
import getMonthName from '../get-month-name';

export const getDateButtonText = (date: Date) => {
  const dayName = getDayName(date, { titleCase: true, abbreviate: true });
  const dayNumber = date.getDate();

  const monthName = getMonthName(date, { abbreviate: true });

  const end = monthName === 'maj' ? '' : '.';

  return `${dayName}. ${dayNumber}. ${monthName}${end}`;
};

export default getDateButtonText;
